export const RESOURCE_ENDPOINT = '/ai-search/search/stream'
